import { render, staticRenderFns } from "./AnimaArticle.vue?vue&type=template&id=24dab830&scoped=true&"
import script from "./AnimaArticle.vue?vue&type=script&lang=ts&"
export * from "./AnimaArticle.vue?vue&type=script&lang=ts&"
import style0 from "./AnimaArticle.vue?vue&type=style&index=0&id=24dab830&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dab830",
  null
  
)

export default component.exports